var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"bg-ctn",staticClass:"bg-ctn"},[(_vm.backgroundTexts)?_c('div',{class:[
      'bg-wrapper',
      ("bg-wrapper--" + _vm.selectedPreview),
      _vm.$store.state.isMobile ? undefined : 'bg-wrapper--no-transition'
    ],attrs:{"data-depth":"0.2"}},_vm._l((_vm.backgroundTexts),function(text,index){return _c('div',{staticClass:"text-bg",class:{'text-bg--visible' : index === _vm.selectedPreview}},[_vm._v("\n      "+_vm._s(text)+"\n    ")])}),0):_c('div',{class:[
      'bg-wrapper',
      ("bg-wrapper--" + _vm.selectedPreview),
      _vm.$store.state.isMobile ? undefined : 'bg-wrapper--no-transition'
    ],attrs:{"data-depth":"0.2"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }